import * as TypeStyle from 'typestyle';
import { TextFieldBorderColors } from './Colors';
type NestedCSSProperties = TypeStyle.types.NestedCSSProperties;

export const FocusIndicatorColors = {
  Default: '#0b5cab',
  Invert: '#aacbff',
  Error: TextFieldBorderColors.Error,
  Valid: TextFieldBorderColors.Valid,
};

export const FocusInsetBorderColors = {
  Default: 'white',
  Invert: '#242424',
};

export const FocusIndicatorWidth = 2;
export const FocusIndicatorInsetWidth = 1;

const focusIndicatorStyles = (color: string, outlineOffset: number = -2): NestedCSSProperties => Object.freeze<NestedCSSProperties>({
  outline: `${FocusIndicatorWidth}px solid ${color}`,
  outlineOffset,
  $nest: {
    '&::-moz-focus-inner': { $unique: true, border: 'none' }
  }
});

const focusInsetBorderStyles = (color: string): NestedCSSProperties => Object.freeze<NestedCSSProperties>({
  boxShadow: `inset 0 0 0 ${FocusIndicatorInsetWidth + 1}px ${color}`, // +1 to account for overlap with outline
});

export const DefaultFocusIndicator = (options?: { invert?: boolean, outlineOffset?: number, inset?: boolean }): NestedCSSProperties => ({
  ...focusIndicatorStyles(options?.invert ? FocusIndicatorColors.Invert : FocusIndicatorColors.Default, options?.outlineOffset),
  ...options?.inset && focusInsetBorderStyles(options?.invert ? FocusInsetBorderColors.Invert : FocusInsetBorderColors.Default),
});
export const ErrorFocusIndicator = focusIndicatorStyles(FocusIndicatorColors.Error);
export const ValidFocusIndicator = focusIndicatorStyles(FocusIndicatorColors.Valid);

export const FocusVisibleIndicator = TypeStyle.style({
  $debugName: 'focus-visible-indicator',
  outline: 'none',
  $nest: {
    '&:focus-visible': DefaultFocusIndicator(),
  }
});